"use strict";

module.exports = {
  bindings: {
    step: '='
  },
  template: require('./treatment-steps-history.html')
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/treatment-steps-history/treatment-steps-history.component.js